import React from 'react';
import useCustomTheme from '../../hooks/theme-hook';
import Markdown from 'react-native-markdown-display';

export interface CustomMarkdownProps {
  children: string;
  style?: any;
}

const CustomMarkdown = (props: CustomMarkdownProps) => {
  const theme = useCustomTheme();
  const insetBackgroundColor = theme.background?.secondary as any;
  const insetBorderColor = theme.borderColor as any;
  const insetTextColor = theme.text?.primary as any;

  return (
    <Markdown
      style={{
        body: { color: insetTextColor, lineHeight: 16 },
        blockquote: { backgroundColor: insetBackgroundColor, borderColor: insetBorderColor },
        code_inline: { color: insetTextColor, backgroundColor: insetBackgroundColor, borderColor: insetBorderColor },
        code_block: { color: insetTextColor, backgroundColor: insetBackgroundColor, borderColor: insetBorderColor },
        fence: { color: insetTextColor, backgroundColor: insetBackgroundColor, borderColor: insetBorderColor },
        bullet_list: { marginBottom: 4 },
        heading4: { marginVertical: 4, fontWeight: 600 },
        list_item: { marginTop: 4 },
        bullet_list_icon: { marginLeft: 0, marginRight: 4 },
        ...(props.style ?? {}),
      }}
    >
      {props.children}
    </Markdown>
  );
};

export default CustomMarkdown;
